import * as React from 'react'

import { IconAttention, InfoAlert } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchResultsListStyled } from './styles/GlobalSearchResultsListStyled'
import { GlobalSearchTruncatedNoticeWrapperStyled } from './styles/GlobalSearchTruncatedNoticeWrapperStyled'
import { type GlobalSearchResultItem } from '../../../../value-objects/GlobalSearchResultItem'
import { GlobalSearchListItem } from '../GlobalSearchListItem'

interface IGlobalSearchResultsListProps {
  items: GlobalSearchResultItem[]
  showTruncatedNotice: boolean
  onResultItemClick: (item: GlobalSearchResultItem) => void
}

export const GlobalSearchResultsList = ({
  items,
  showTruncatedNotice,
  onResultItemClick,
}: IGlobalSearchResultsListProps) => {
  const intl = useProcurifyIntl()

  return (
    <GlobalSearchResultsListStyled>
      {items.map((item) => (
        <GlobalSearchListItem
          key={item.uuid}
          type={item.type}
          id={item.id}
          metadata={item.metadata}
          extraIdentifier={item.label}
          onClick={() => onResultItemClick(item)}
        />
      ))}
      {showTruncatedNotice && (
        <GlobalSearchTruncatedNoticeWrapperStyled>
          <InfoAlert icon={<IconAttention />}>
            {intl.formatMessage(messages.truncatedNotice)}
          </InfoAlert>
        </GlobalSearchTruncatedNoticeWrapperStyled>
      )}
    </GlobalSearchResultsListStyled>
  )
}
